import React, { useEffect } from "react";
import DynamicAboutSection from "../../components/CampusTeamBuilding/DynamicAbout";
import TeamActivitySection from "../../components/CampusTeamBuilding/TeamActivitySection";
import DynamicCorporateTeamSection from "../../components/CampusTeamBuilding/DynamicCorporateTeamSection";
import DynamicMethodSection from "../../components/CampusTeamBuilding/DynamicMethodSection";
import HowTeamsWorkSection from "../../components/CampusTeamBuilding/HowTeamsWorkSection";

import DynamicGallerySection from "../../components/CampusTeamBuilding/DynamicGallerySection";
import DynamicExpertiseSection from "../../components/CampusTeamBuilding/DynamicExpertiseSection";
import DynamicContactSection from "../../components/CampusTeamBuilding/DynamicContactSection";
import CampusTeamBuildingHeaderSection from "../../components/CampusTeamBuilding/CampusTeamBuildingHeaderSection";
import CampusTeamBuildingTestimonial from "../../components/CampusTeamBuilding/CampusTeamBuildingTestimonial";

import CampusTeamBuildingFaqSection from "../../components/CampusTeamBuilding/CampusTeamBuildingFaqSection";
import campusTeamBuildingData from "../../data/campusTeamBuildingData.json";
import "../Dynamic/dynamic.css";


export default function CampusTeamBuilding({ data = campusTeamBuildingData }) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="dynamic-page dynamic-team-building-page">
      <CampusTeamBuildingHeaderSection data={data.header} />
      <DynamicAboutSection data={data.dynamicAbout} />  
      <TeamActivitySection data={data.teamActivities} />
      <DynamicCorporateTeamSection data={data.corporateTeam} />
      <DynamicMethodSection data={data.method} />
      <HowTeamsWorkSection data={data.teamWork} />
     
      <DynamicGallerySection data={data.gallery} />
      <DynamicExpertiseSection data={data.expertise} />
      <CampusTeamBuildingTestimonial data={data.testimonials} />  
      <CampusTeamBuildingFaqSection data={data.faq} />
      <DynamicContactSection data={data.contact} />
    </div>
  );
}
